import React from 'react';
import Canvas from './Canvas';
import CanvasContent from './CanvasContent';
import createCircuit from './createCircuit';
import useFigure from './useFigure';

const Circuit = React.forwardRef(({ data }, ref) => {
  const {
    gates, registers, width, height, classicRegisters,
  } = createCircuit(data);

  const CanvasFill = useFigure('canvasFill');
  CanvasFill({ fill: '#060E1F', width, height });

  return (
    <Canvas ref={ref} canvasWidth={width} canvasHeight={height} gates={gates}>
      <CanvasContent
        registers={registers}
        gates={gates}
        width={width}
        height={height}
        classicRegisters={classicRegisters}
      />
    </Canvas>
  );
});
export default Circuit;
